import { core_apimessages_ShippingMethod as ShippingMethod } from '../schemas/rql';

interface CheckoutOrder {
  shippingMethod?: {
    type?: string;
  }
}

interface Checkout {
  orders?: CheckoutOrder[];
}

export function isCheckoutLocalPickupOnly(checkout: Checkout) {
  return checkout.orders.every((order) => order.shippingMethod?.type === ShippingMethod.LOCAL);
}

export function isCheckoutShipped(checkout: Checkout) {
  const shippingMethods = checkout.orders.map((order) => order.shippingMethod?.type);

  return shippingMethods.some((shippingMethodType) =>
    !(shippingMethodType === ShippingMethod.LOCAL || shippingMethodType === ShippingMethod.DIGITAL_DELIVERY),
  );
}
